import React from 'react';
import { Bell, MessageCircle, Mail, Smartphone } from 'lucide-react';
import { TelegramNotificationSettings } from '../components/Notifications/TelegramNotificationSettings';
import { TelegramAIAssistant } from '../components/Notifications/TelegramAIAssistant';

export const NotificationsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-white flex items-center gap-3">
          <Bell className="w-8 h-8 text-orange-500" />
          Powiadomienia i Asystent AI
        </h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <div className="bg-zinc-800 rounded-lg p-6 border border-zinc-700">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-3 bg-blue-600 rounded-lg">
              <MessageCircle className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">Telegram</h3>
              <p className="text-sm text-gray-400">Błyskawiczne powiadomienia + AI</p>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-gray-300">Status</span>
              <span className="text-green-400 font-medium">Aktywny</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-300">Bot</span>
              <span className="text-white">@plexisystem_ai_bot</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-300">AI Assistant</span>
              <span className="text-purple-400 font-medium">Włączony</span>
            </div>
          </div>
        </div>

        <div className="bg-zinc-800 rounded-lg p-6 border border-zinc-700">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-3 bg-purple-600 rounded-lg">
              <Mail className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">Email</h3>
              <p className="text-sm text-gray-400">Powiadomienia mailowe</p>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-gray-300">Status</span>
              <span className="text-green-400 font-medium">Aktywny</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-300">Adres</span>
              <span className="text-white">oferty@plexisystem.pl</span>
            </div>
          </div>
        </div>

        <div className="bg-zinc-800 rounded-lg p-6 border border-zinc-700">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-3 bg-gray-600 rounded-lg">
              <Smartphone className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">SMS</h3>
              <p className="text-sm text-gray-400">Krytyczne alerty</p>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-gray-300">Status</span>
              <span className="text-gray-400 font-medium">Nieaktywny</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-300">Dostawca</span>
              <span className="text-gray-500">Brak konfiguracji</span>
            </div>
          </div>
        </div>
      </div>

      {/* Nowy moduł asystenta AI */}
      <TelegramAIAssistant />

      {/* Ustawienia Telegram */}
      <TelegramNotificationSettings />
    </div>
  );
};
